<mat-card appearance="outlined" [formGroup]="configForm" class="card">
  <div class="flex-row">
    <div style="flex: 0 0 15%">
      <button
        matButton="elevated"
        color="primary"
        (click)="loadConfig()"
        class="app-panel-button"
        i18n
        [disabled]="configLoaded === true"
      >
        Load config from server
      </button>
      <button
        type="submit"
        matButton="elevated"
        color="accent"
        (click)="saveConfig()"
        class="app-panel-button"
        i18n
        [disabled]="configLoaded !== true || !configForm.valid"
      >
        Save config
      </button>
      <button
        matButton="elevated"
        (click)="clearRefresh()"
        class="app-panel-button"
        i18n
        [disabled]="configLoaded === null"
      >
        Clear and Refresh
      </button>
    </div>
    <div style="flex: 1 0 60%">
      @if (configLoaded) {
        @if (!noConfigDefined) {
          <div class="flex-col center-start">
            <div class="app-details-subtitle" i18n>General Settings</div>
            <div class="flex-row space-between-baseline">
              <div class="app-details-subtitle2" i18n>
                Due Date - Warning time [hours]:
              </div>
              <mat-form-field>
                <label>
                  <input
                    type="number"
                    class="app-input"
                    matInput
                    formControlName="warning"
                  />
                </label>
              </mat-form-field>
            </div>
            <div class="flex-row space-between-baseline">
              <div class="app-details-subtitle2" i18n>
                Due Date - Alert time [hours]:
              </div>
              <mat-form-field>
                <label>
                  <input
                    type="number"
                    class="app-input"
                    matInput
                    formControlName="alert"
                  />
                </label>
              </mat-form-field>
            </div>
            <div class="flex-row space-between-baseline">
              <div class="app-details-subtitle2" i18n>
                Order Numbering - year from:
              </div>
              <mat-radio-group formControlName="orderNumberDateFrom">
                <mat-radio-button value="due_date"><span i18n>Due date</span></mat-radio-button>
                <mat-radio-button value="created"><span i18n>Order created date</span></mat-radio-button>
              </mat-radio-group>

            </div>
            <div class="flex-row space-between-baseline">
              <div class="app-details-subtitle2" i18n>
                Order - allow order without devices:
              </div>
              <mat-checkbox class="app-checkbox"
                [checked]="configForm.controls.allowOrderWoDevices.value"
                (change)="
              configForm.controls.allowOrderWoDevices.setValue(
                !configForm.controls.allowOrderWoDevices.value
              )
            "
               />
            </div>
            <div class="flex-row space-between-baseline">
              <div class="app-details-subtitle2" i18n>
                Order - department in orders:
              </div>
              <mat-checkbox class="app-checkbox"
                [checked]="configForm.controls.departmentsEnable.value"
                (change)="
              configForm.controls.departmentsEnable.setValue(
                !configForm.controls.departmentsEnable.value
              )
            "
               />
            </div>
            <div class="flex-row space-between-baseline">
              <div class="app-details-subtitle2" i18n>
                Sequential order actions - enabled:
              </div>
              <mat-checkbox class="app-checkbox"
                [checked]="configForm.controls.sequentialActionsEnable.value"
                (change)="
              configForm.controls.sequentialActionsEnable.setValue(
                !configForm.controls.sequentialActionsEnable.value
              )
            "
               />
            </div>
            <div class="flex-row space-between-baseline">
              <div class="app-details-subtitle2" i18n>
                Customer - enable duplicated VAT code:
              </div>
              <mat-checkbox class="app-checkbox"
                [checked]="configForm.controls.customerAllowDuplicatedVATcode.value"
                (change)="
              configForm.controls.customerAllowDuplicatedVATcode.setValue(
                !configForm.controls.customerAllowDuplicatedVATcode.value
              )
            "
               />
            </div>
            <div class="flex-row space-between-baseline">
              <div class="app-details-subtitle2" i18n>Enable supervisor role:</div>
              <mat-checkbox class="app-checkbox"
                [checked]="configForm.controls.enableSupervisorRole.value"
                (change)="
              configForm.controls.enableSupervisorRole.setValue(
                !configForm.controls.enableSupervisorRole.value
              )
            "
               />
            </div>
            <div class="app-details-subtitle" i18n>Application</div>
            <div class="flex-row space-between-baseline">
              <div class="app-details-subtitle2" i18n>Hide Inbox:</div>
              <mat-checkbox class="app-checkbox"
                [checked]="configForm.controls.menuHideRequests.value"
                (change)="
              configForm.controls.menuHideRequests.setValue(
                !configForm.controls.menuHideRequests.value
              )
            "
               />
            </div>
            <div class="flex-row space-between-baseline">
              <div class="app-details-subtitle2" i18n>Hide Service Agreements:</div>
              <mat-checkbox class="app-checkbox"
                [checked]="configForm.controls.menuHideAgreements.value"
                (change)="
              configForm.controls.menuHideAgreements.setValue(
                !configForm.controls.menuHideAgreements.value
              )
            "
               />
            </div>
            <div class="flex-row space-between-baseline">
              <div class="app-details-subtitle2" i18n>Hide Warehouses:</div>
              <mat-checkbox class="app-checkbox"
                [checked]="configForm.controls.menuHideWarehouses.value"
                (change)="
              configForm.controls.menuHideWarehouses.setValue(
                !configForm.controls.menuHideWarehouses.value
              )
            "
               />
            </div>
            <div class="flex-row space-between-baseline">
              <div class="app-details-subtitle2" i18n>Hide Work Time:</div>
              <mat-checkbox class="app-checkbox"
                [checked]="configForm.controls.menuHideWorkTime.value"
                (change)="
              configForm.controls.menuHideWorkTime.setValue(
                !configForm.controls.menuHideWorkTime.value
              )
            "
               />
            </div>
            <div class="flex-row space-between-baseline">
              <div class="app-details-subtitle2" i18n>Hide Products:</div>
              <mat-checkbox class="app-checkbox"
                [checked]="configForm.controls.menuHideProducts.value"
                (change)="
              configForm.controls.menuHideProducts.setValue(
                !configForm.controls.menuHideProducts.value
              )
            "
               />
            </div>
            <div class="app-details-subtitle" i18n>Mobile Application</div>
            <div class="flex-row space-between-baseline">
              <div class="app-details-subtitle2" i18n>
                Date Format [dd.MM.yyyy]:
              </div>
              <mat-form-field>
                <label>
                  <input class="app-input" matInput formControlName="dateFormat"/>
                </label>
              </mat-form-field>
            </div>
            <div class="flex-row space-between-baseline">
              <div class="app-details-subtitle2" i18n>Time Format [HH:mm:ss]:</div>
              <mat-form-field>
                <label>
                  <input class="app-input" matInput formControlName="timeFormat"/>
                </label>
              </mat-form-field>
            </div>
            <div class="flex-row space-between-baseline">
              <div class="app-details-subtitle2" i18n>
                Date & Time Format [dd.MM.yyyy HH:mm]:
              </div>
              <mat-form-field>
                <label>
                  <input
                    class="app-input"
                    matInput
                    formControlName="dateTimeFormat"
                  />
                </label>
              </mat-form-field>
            </div>
            <div class="flex-row space-between-baseline">
            </div>
            <div class="flex-row space-between-baseline">
              <div class="app-details-subtitle2" i18n>Enable user schedule:</div>
              <mat-checkbox class="app-checkbox"
                [checked]="configForm.controls.enableUserSchedule.value"
                (change)="
              configForm.controls.enableUserSchedule.setValue(
                !configForm.controls.enableUserSchedule.value
              )
            "
               />
            </div>
            <div class="flex-row space-between-baseline">
              <div class="app-details-subtitle2" i18n>
                Status change when off work:
              </div>
              <mat-checkbox class="app-checkbox"
                [checked]="configForm.controls.statusChangeWorkOff.value"
                (change)="
              configForm.controls.statusChangeWorkOff.setValue(
                !configForm.controls.statusChangeWorkOff.value
              )
            "
               />
            </div>
            <div class="flex-row space-between-baseline">
              <div class="app-details-subtitle2" i18n>
                Adding notes when off work:
              </div>
              <mat-checkbox class="app-checkbox"
                [checked]="configForm.controls.noteAddWorkOff.value"
                (change)="
              configForm.controls.noteAddWorkOff.setValue(
                !configForm.controls.noteAddWorkOff.value
              )
            "
               />
            </div>
            <div class="flex-row space-between-baseline">
              <div class="app-details-subtitle2" i18n>
                Adding photos when off work:
              </div>
              <mat-checkbox class="app-checkbox"
                [checked]="configForm.controls.photoAddWorkOff.value"
                (change)="
              configForm.controls.photoAddWorkOff.setValue(
                !configForm.controls.photoAddWorkOff.value
              )
            "
               />
            </div>
            <div class="flex-row space-between-baseline">
              <div class="app-details-subtitle2" i18n>Team Lead menu:</div>
              <mat-checkbox class="app-checkbox"
                [checked]="configForm.controls.teamLeadOn.value"
                (change)="
              configForm.controls.teamLeadOn.setValue(
                !configForm.controls.teamLeadOn.value
              )
            "
               />
            </div>
            <div class="flex-row space-between-baseline">
              <div class="app-details-subtitle2" i18n>
                Adding photos from gallery:
              </div>
              <mat-checkbox class="app-checkbox"
                formControlName="allowPhotoFromGallery"
               />
            </div>
            <div class="flex-row space-between-baseline">
              <div class="app-details-subtitle2" i18n>
                Adding pdf to order:
              </div>
              <mat-checkbox class="app-checkbox"
                formControlName="allowAddingPdfToOrder"
               />
            </div>
            <div class="app-details-subtitle" i18n>Forms Settings</div>
            <div class="flex-row space-between-baseline">
              <div class="app-details-subtitle2" i18n>Allow save as draft:</div>
              <mat-checkbox class="app-checkbox"
                formControlName="formAllowSaveAsDraft"
               />
            </div>
            <div class="flex-row space-between-baseline">
              <div class="app-details-subtitle2" i18n>
                Allow the new form as a copy from PDF:
              </div>
              <mat-checkbox class="app-checkbox"
                formControlName="formAllowCopyFromPDF"
               />
            </div>
            <div class="flex-row space-between-baseline">
              <div class="app-details-subtitle2" i18n>
                Font size factor for fields (on mobile dev):
              </div>
              <mat-form-field>
                <label>
                  <input
                    type="number"
                    class="app-input"
                    matInput
                    formControlName="formFieldFontFactor"
                  />
                </label>
              </mat-form-field>
            </div>
            <div class="flex-row space-between-baseline">
              <div class="app-details-subtitle2" i18n>
                Font size factor for tables (on mobile dev):
              </div>
              <mat-form-field>
                <label>
                  <input
                    type="number"
                    class="app-input"
                    matInput
                    formControlName="formTableFontFactor"
                  />
                </label>
              </mat-form-field>
            </div>
            <div class="flex-row space-between-baseline">
              <div class="app-details-subtitle2" i18n>
                Table in forms - max no of rows:
              </div>
              <mat-form-field>
                <label>
                  <input
                    type="number"
                    class="app-input"
                    matInput
                    formControlName="formTableMaxRow"
                  />
                </label>
              </mat-form-field>
            </div>
            <div class="flex-row space-between-baseline">
              <div class="app-details-subtitle2" i18n>
                Table in forms - max no of columns:
              </div>
              <mat-form-field>
                <label>
                  <input
                    type="number"
                    class="app-input"
                    matInput
                    formControlName="formTableMaxCol"
                  />
                </label>
              </mat-form-field>
            </div>
            <div class="app-details-subtitle" i18n>Email notifications</div>
            <div class="app-remark" i18n>
              Changes of the email addresses needs adjustments in the email sending
              system. Please contact the system administrator
            </div>
            <div class="flex-row space-between-baseline">
              <div class="app-details-subtitle2" i18n>
                Address of the email sender:
              </div>
              <mat-form-field>
                <label>
                  <input
                    class="app-input-text"
                    matInput
                    formControlName="formEmailAddress"
                  />
                </label>
              </mat-form-field>
            </div>
            <div class="flex-row space-between-baseline">
              <div class="app-details-subtitle2" i18n>
                Send copy of the email to address:
              </div>
              <mat-form-field>
                <label>
                  <input
                    class="app-input-text"
                    matInput
                    formControlName="formCopyEmailAddress"
                  />
                </label>
              </mat-form-field>
            </div>
            <div class="flex-row space-between-baseline">
              <div class="app-details-subtitle2" i18n>Email form template id:</div>
              <mat-form-field>
                <label>
                  <input
                    class="app-input-text"
                    matInput
                    formControlName="formEmailTemplateId"
                  />
                </label>
              </mat-form-field>
            </div>
            <div class="app-details-subtitle" i18n>Warehouses</div>
            <div class="flex-row space-between-baseline">
              <div class="app-details-subtitle2" i18n>Enable stock orders:</div>
              <mat-checkbox class="app-checkbox"
                formControlName="warehouseEnableStockOrder"
               />
            </div>
            <!-- Warehouse Release Table Config Section -->
            <div class="flex-row space-between-baseline mb-4">
              <div class="app-details-subtitle2" i18n>Warehouse Release Table:</div>
            </div>

            <!-- Table-like form for all 4 columns -->

            <div formGroupName="warehouseReleaseTableConfig" class="grid grid-cols-4 gap-4 mb-6 p-4 bg-gray-50 rounded">

              <!-- itemKey Column -->
              <div class="col-span-1" formGroupName="itemKey">
                <div class="font-medium mb-2">itemKey</div>

                <mat-form-field class="w-full">
                  <mat-label i18n="@@Key">Key</mat-label>
                  <mat-select formControlName="key" [disabled]="true">
                    <mat-option value="itemKey">itemKey</mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-form-field class="w-full">
                  <mat-label i18n="@@FieldType">Field Type</mat-label>
                  <mat-select formControlName="formFieldType" [disabled]="true">
                    <mat-option [value]="3">3</mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-form-field class="w-full">
                  <mat-label i18n="@@FieldName">Name</mat-label>
                  <input matInput formControlName="name"/>
                </mat-form-field>

                <mat-form-field class="w-full">
                  <mat-label i18n="@@FieldSort">Sort</mat-label>
                  <input matInput type="number" formControlName="sort"/>
                </mat-form-field>

                <mat-form-field class="w-full">
                  <mat-label i18n="@@FieldWidth">Width</mat-label>
                  <input matInput type="number" formControlName="width"/>
                </mat-form-field>

                <mat-checkbox formControlName="visible">
                  <span i18n="@@FieldVisible">Visible</span>
                </mat-checkbox>
              </div>

              <!-- quantity Column -->
              <div class="col-span-1" formGroupName="quantity">
                <div class="font-medium mb-2">quantity</div>

                <mat-form-field class="w-full">
                  <mat-label i18n="@@Key">Key</mat-label>
                  <mat-select formControlName="key" [disabled]="true">
                    <mat-option value="quantity">quantity</mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-form-field class="w-full">
                  <mat-label i18n="@@FieldType">Field Type</mat-label>
                  <mat-select formControlName="formFieldType" [disabled]="true">
                    <mat-option [value]="5">5</mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-form-field class="w-full">
                  <mat-label i18n="@@FieldName">Name</mat-label>
                  <input matInput formControlName="name"/>
                </mat-form-field>

                <mat-form-field class="w-full">
                  <mat-label i18n="@@FieldSort">Sort</mat-label>
                  <input matInput type="number" formControlName="sort"/>
                </mat-form-field>

                <mat-form-field class="w-full">
                  <mat-label i18n="@@FieldWidth">Width</mat-label>
                  <input matInput type="number" formControlName="width"/>
                </mat-form-field>

                <mat-checkbox formControlName="visible">
                  <span i18n="@@FieldVisible">Visible</span>
                </mat-checkbox>
              </div>

              <!-- name Column -->
              <div class="col-span-1" formGroupName="name">
                <div class="font-medium mb-2">name</div>

                <mat-form-field class="w-full">
                  <mat-label i18n="@@Key">Key</mat-label>
                  <mat-select formControlName="key" [disabled]="true">
                    <mat-option value="name">name</mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-form-field class="w-full">
                  <mat-label i18n="@@FieldType">Field Type</mat-label>
                  <mat-select formControlName="formFieldType" [disabled]="true">
                    <mat-option [value]="3">3</mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-form-field class="w-full">
                  <mat-label i18n="@@FieldName">Name</mat-label>
                  <input matInput formControlName="name"/>
                </mat-form-field>

                <mat-form-field class="w-full">
                  <mat-label i18n="@@FieldSort">Sort</mat-label>
                  <input matInput type="number" formControlName="sort"/>
                </mat-form-field>

                <mat-form-field class="w-full">
                  <mat-label i18n="@@FieldWidth">Width</mat-label>
                  <input matInput type="number" formControlName="width"/>
                </mat-form-field>

                <mat-checkbox formControlName="visible">
                  <span i18n="@@FieldVisible">Visible</span>
                </mat-checkbox>
              </div>

              <!-- unit Column -->
              <div class="col-span-1" formGroupName="unit">
                <div class="font-medium mb-2">unit</div>

                <mat-form-field class="w-full">
                  <mat-label i18n="@@Key">Key</mat-label>
                  <mat-select formControlName="key" [disabled]="true">
                    <mat-option value="unit">unit</mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-form-field class="w-full">
                  <mat-label i18n="@@FieldType">Field Type</mat-label>
                  <mat-select formControlName="formFieldType" [disabled]="true">
                    <mat-option [value]="3">3</mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-form-field class="w-full">
                  <mat-label i18n="@@FieldName">Name</mat-label>
                  <input matInput formControlName="name"/>
                </mat-form-field>

                <mat-form-field class="w-full">
                  <mat-label i18n="@@FieldSort">Sort</mat-label>
                  <input matInput type="number" formControlName="sort"/>
                </mat-form-field>

                <mat-form-field class="w-full">
                  <mat-label i18n="@@FieldWidth">Width</mat-label>
                  <input
                    matInput
                    type="number"
                    formControlName="width"
                    [readonly]="!configForm.get('warehouseReleaseTableConfig.unit.visible')?.value"
                    [class.bg-gray-200]="!configForm.get('warehouseReleaseTableConfig.unit.visible')?.value"
                  />
                </mat-form-field>

                <mat-checkbox
                  formControlName="visible"
                  (change)="onUnitVisibilityChange($event)">
                  <span i18n="@@FieldVisible">Visible</span>
                </mat-checkbox>
              </div>

              <!-- description Column -->
              <div class="col-span-1" formGroupName="description">
                <div class="font-medium mb-2">description</div>

                <mat-form-field class="w-full">
                  <mat-label i18n="@@Key">Key</mat-label>
                  <mat-select formControlName="key" [disabled]="true">
                    <mat-option value="description">description</mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-form-field class="w-full">
                  <mat-label i18n="@@FieldType">Field Type</mat-label>
                  <mat-select formControlName="formFieldType" [disabled]="true">
                    <mat-option [value]="3">3</mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-form-field class="w-full">
                  <mat-label i18n="@@FieldName">Name</mat-label>
                  <input matInput formControlName="name"/>
                </mat-form-field>

                <mat-form-field class="w-full">
                  <mat-label i18n="@@FieldSort">Sort</mat-label>
                  <input matInput type="number" formControlName="sort"/>
                </mat-form-field>

                <mat-form-field class="w-full">
                  <mat-label i18n="@@FieldWidth">Width</mat-label>
                  <input
                    matInput
                    type="number"
                    formControlName="width"
                    [readonly]="!configForm.get('warehouseReleaseTableConfig.description.visible')?.value"
                    [class.bg-gray-200]="!configForm.get('warehouseReleaseTableConfig.description.visible')?.value"
                  />
                </mat-form-field>

                <mat-checkbox
                  formControlName="visible"
                  (change)="onDescriptionVisibilityChange($event)">
                  <span i18n="@@FieldVisible">Visible</span>
                </mat-checkbox>
              </div>
            </div>


            <div class="flex-row space-between-baseline">
              <div class="app-details-subtitle2" i18n>Allow negative stock:</div>
              <mat-checkbox class="app-checkbox"
                formControlName="warehouseAllowNegativeStock"
               />
            </div>
            <div class="flex-row space-between-baseline">
              <div class="app-details-subtitle2" i18n>
                Material releases: hide materials with zero stock
              </div>
              <mat-checkbox class="app-checkbox"
                formControlName="warehouseNotShowZeroStock"
               />
            </div>
            <div class="flex-row space-between-baseline">
              <div class="app-details-subtitle2" i18n>
                Additional serviceman may release materials:
              </div>
              <mat-checkbox class="app-checkbox"
                formControlName="warehouseAllowAdditionalSrvm"
               />
            </div>
            <div class="app-details-subtitle2" i18n>
              Order statuses when material release is allowed:
            </div>
            <mat-selection-list
              formControlName="warehouseAllowedStatuses"
              [compareWith]="compareStatuses"
            >
              @for (stat of statuses; track stat) {
                <mat-list-option checkboxPosition="before" [value]="stat">
                  {{ stat.name }}
                </mat-list-option>
              }
            </mat-selection-list>
            <div class="app-details-subtitle" i18n>Branches</div>
            <div class="flex-row space-between-baseline">
              <div class="app-details-subtitle2" i18n>
                Enable branches in the Dispatcher App:
              </div>
              <mat-checkbox class="app-checkbox"
                [checked]="configForm.controls.branchesEnable.value"
                (change)="
              configForm.controls.branchesEnable.setValue(
                !configForm.controls.branchesEnable.value
              )
            "
               />
            </div>
            <div class="flex-row space-between-baseline">
              <div class="app-details-subtitle2" i18n>
                Branch Admin is allowed to change branch :
              </div>
              <mat-checkbox class="app-checkbox"
                [checked]="configForm.controls.branchesChangeByBranchAdmin.value"
                (change)="
              configForm.controls.branchesChangeByBranchAdmin.setValue(
                !configForm.controls.branchesChangeByBranchAdmin.value
              )
            "
               />
            </div>
            <div class="flex-row space-between-baseline">
              <div class="app-details-subtitle2" i18n>
                Remove the team when order assigned to other branch :
              </div>
              <mat-checkbox class="app-checkbox"
                formControlName="branchesRemoveTeamFromOrder"
               />
            </div>

            <div class="app-details-subtitle" i18n>Live tracking</div>
            <div class="flex-row space-between-baseline">
              <div class="app-details-subtitle2" i18n>Enable live tracking:</div>
              <mat-checkbox class="app-checkbox"
                formControlName="trackingEnable"
               />
            </div>
            <div class="flex-row space-between-baseline">
              <div class="app-details-subtitle2" i18n>Live tracking in background (force permission):</div>
              <mat-checkbox class="app-checkbox"
                formControlName="trackingInBackground"
               />
            </div>
            <div class="flex-row space-between-baseline">
              <div class="app-details-subtitle2" i18n>Live tracking - keep history (days):</div>
              <mat-form-field>
                <label>
                  <input
                    type="number"
                    class="app-input"
                    matInput
                    formControlName="trackingHistoryDays"
                  />
                </label>
              </mat-form-field>
            </div>
            <div class="flex-row space-between-baseline">
              <div class="app-details-subtitle2" i18n>Live tracking calculate distance:</div>
              <mat-checkbox class="app-checkbox"
                formControlName="trackingCalculateDistance"
               />
            </div>
            <div class="flex-row space-between-baseline">
              <div class="app-details-subtitle2" i18n>Calculate distance - keep history (days):</div>
              <mat-form-field>
                <label>
                  <input
                    type="number"
                    class="app-input"
                    matInput
                    formControlName="trackingDistanceHistoryDays"
                  />
                </label>
              </mat-form-field>
            </div>
            <div class="app-details-subtitle" i18n>Security</div>

            <div class="flex-row space-between-baseline">
              <div class="app-details-subtitle2" i18n>Enable MFA:</div>
              <mat-checkbox class="app-checkbox"
                formControlName="securityEnableMFA"
               />
            </div>

            <div class="flex-row space-between-baseline">
              <div class="app-details-subtitle2" i18n>MFA via SMS:</div>
              <mat-checkbox class="app-checkbox"
                formControlName="securityMFASMS"
               />
            </div>

            <div class="flex-row space-between-baseline">
              <div class="app-details-subtitle2" i18n>MFA via Authenticator App:</div>
              <mat-checkbox class="app-checkbox"
                formControlName="securityMFAAuthApp"
               />
            </div>

            <div class="flex-row space-between-baseline">
              <div class="app-details-subtitle2" i18n>MFA via local phone biometrics:</div>
              <mat-checkbox class="app-checkbox"
                formControlName="securityMFAPhoneLocalBiometric"
               />
            </div>

            <div class="flex-row space-between-baseline">
              <div class="app-details-subtitle2" i18n>Enable biometric login:</div>
              <mat-checkbox class="app-checkbox"
                formControlName="securityLoginLocalBiometric"
               />
            </div>

          </div>
        } @else {
          <button
            matButton="elevated"
            color="primary"
            (click)="createConfig()"
            class="app-panel-button"
            i18n
          >
            Create new config
          </button>
        }
      }
      @if (configLoaded === null) {
        <p class="app-message" i18n>No config loaded from server</p>
      }
      @if (configLoaded === false) {
        <p class="app-message" i18n>Error when loading config from server</p>
      }
    </div>
  </div>
</mat-card>
